import { Player } from "@lottiefiles/react-lottie-player";
import animacion from "../../imagenes/AnimacionesVarias/DispositivoMovilNoDetectado.json";
import Backdrop from "@mui/material/Backdrop";
import animacionLP from "../../imagenes/AnimacionesVarias/LoadingMap.json";
import { dispositivo_movil_no_detectado } from "../../utils/traductor";

export function DispositivoMovilNoDetectado() {
  return (
    <div>
      <div style={{ textAlign: "center", color: "#DC030E" }}>
        {dispositivo_movil_no_detectado}
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open="True"
      >
        <Player
          src={animacionLP}
          className="player"
          loop
          autoplay
          style={{ height: 200 }}
        />
      </Backdrop>
    </div>
  );
}
